import { createSlice } from '@reduxjs/toolkit';

const { user_type: userType } = JSON.parse(document.body.dataset.currentUser);
const { name, email } = JSON.parse(document.body.dataset.user);
const header = document.getElementById('Header');
const dataset = header?.dataset || {};
const { browserLanguage, isRequestedLanguageDefault, userLanguage } = dataset;

const initialState = {
  userType,
  browserLanguage,
  isRequestedLanguageDefault,
  userLanguage,
  name,
  email,
};

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
});

export default currentUserSlice.reducer;
